<script setup lang="ts">
import { ref } from 'vue';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import Desktop from './Desktop.vue'
import { useI18n } from 'vue-i18n';

import { useViewStore } from '@/stores/viewStore'

import { useUserStore } from '@/stores/userStore';

const viewStore = useViewStore();
const { t, locale } = useI18n();


const email = ref('');
const password = ref('');
const loading = ref(false);
const error = ref('');


//const customerInfo = get_data_attr("customer");

const login = async () => {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  try {
    const response = await fetch('/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken || ''
      },
      body: JSON.stringify({ email: email.value, password: password.value }),
    });

    const contentType = response.headers.get('Content-Type') || '';
    const isJson = contentType.includes('application/json');

    if (!isJson) {
      // Server returned HTML (e.g. CSRF error or redirect) – often after using browser Back
      alert('Session scheint abgelaufen zu sein. Bitte die Seite neu laden (F5) und erneut versuchen.');
      return;
    }

    const data = await response.json();

    if (response.ok) {
	  viewStore.setUsername(email.value);
	  viewStore.setViewDesktop();
	  viewStore.currentCustomer = data["customer_id"];
	  viewStore.currentStandort = data["standort_id"];
      window.location.href = '/';
    } else {
      alert(t('view.login') + ":" + (data.message || 'Unknown error'));
    }
  } catch (err) {
    alert('Fehler aufgetreten. Wenn Sie den Back-Button verwendet haben, bitte die Seite neu laden (F5) und erneut versuchen.');
  }
};
</script>

<template>
  <Desktop>
	<div class="w-1/2 flex flex-col justify-top">
		<Card class="w-full max-w-sm hoeppner-bg">
		  <CardHeader>
		    <CardTitle class="text-center">Login</CardTitle>
		  </CardHeader>
		  <CardContent>
		    <form @submit.prevent="login" class="space-y-4">
		      <Input
		        type="text"
		        placeholder="Email"
		        v-model="email"
		        required
		      />

		      <Input
		        type="password"
		        placeholder="Password"
		        v-model="password"
		        required
		      />

		      <div v-if="error" class="text-red-500 text-sm">{{ error }}</div>

		      <Button :disabled="loading" class="w-full greenbutton">
		        {{ loading ? 'Logging in...' : 'Login' }}
		      </Button>
		    </form>
		  </CardContent>
		</Card>
	</div>
  </Desktop>
</template>

<style>

.w-button {
    width: 300px !important;	
}

.hoeppner-bg {
	background-color: #F4F3F3 !important;
	border-radius: 0 !important;
}

.greenbutton {
	background-color: #80BA27 !important;
}
</style>